import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseService } from '../../base';
import { ProductPrice } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProductPriceListService extends TmsWebBaseService {
  constructor() {
    super('PriceList');
  }

  getAllPriceListsForProduct(productId: string): Observable<ProductPrice[]> {
    return this.httpService.get<ProductPrice[]>(`${this.apiUrl}/GetAllPriceListsForProduct?productId=${productId}`);
  }
}
